import React from 'react'
import {connect} from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableFooter'
import Paper from '@material-ui/core/Paper'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import ClearIcon from '@material-ui/icons/Clear'
import BlockIcon from '@material-ui/icons/Block'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Slide from '@material-ui/core/Slide'
import _ from 'lodash';
import Pagination from '../../../../../uis/pagination'
import NoData from '../../../../../uis/noData'
import * as actions from '../reducers/list'
import ListForm from './listForm'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    textField: {
        width: 300,
    },
    dislogActions: {
        display: 'flex',
        justifyContent: 'space-around',
        margin: theme.spacing.unit * 3
    },
    contentCell: {
        maxWidth: 100,
    },
    formControl: {
        width: 300
    },
    editButton: {
        color: '#7f43a3'
    },
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: 1
    },
    contentRoot: {
        margin: theme.spacing.unit * 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    }
})
function Transition(props) {
    return <Slide {...props} direction="up" />
}
class Modules extends React.Component {
    componentDidMount() {
        const {dispatch} = this.props
        dispatch(actions.getList())
        dispatch(actions.getRoleList())
    }
    handleFormSubmit(data) {
        const {dispatch} = this.props
        const formData = _.clone(data);
        console.info(formData)
        formData.tableName = formData.tableName.toLowerCase();
        formData.camelName = _.camelCase(formData.tableName);
        formData.className = _.capitalize(formData.camelName);
        formData.namePrefix = formData.tableName.toUpperCase();
        formData.apiPrefix = formData.tableName.replace(/_/g, '-');
        formData.fields = formData.fields.map((field)=>{
            field = {...field, camelName: _.camelCase(field.name)}
            if (_.includes(['datetime', 'timestamp'], field.dataType)) {
                return {...field, componentType: 'Datetime', operator: 'eq'}
            }
            if (_.includes(['float', 'double', 'int'], field.dataType)) {
                return {...field, componentType: 'Number', operator: 'eq'}
            }
            if (_.includes(['tinyint'], field.dataType)) {
                return {...field, componentType: 'Select', data: JSON.stringify([{name: '是', value: true}, {name: '否', value: false}]), operator: 'eq'}
            }
            if (_.includes(['text'], field.dataType)) {
                return {...field, componentType: 'Textarea', operator: 'contains'}
            }
            if (_.includes(['enum'], field.dataType)) {
                return {...field, componentType: 'Select', data: JSON.stringify(field.arg1.split(',').map(item=>({name: item, value: item}))), operator: 'eq'}
            }
            return {...field, componentType: 'Text', operator: 'contains'}
        })
        formData.roleList = formData.roles.map(item=>{
            const key = Object.keys(item)[0];
            return item[key] ? key : "";
        }).filter(item=>!!item);
        formData.funs = [formData.hasAdd ? "新增" : "", formData.hasDelete ? "删除" : "", formData.hasUpdate ? "修改" : "", formData.hasQuery ? "查询" : ""].filter(item=>!!item);
        dispatch(actions.add(formData))
    }
    render() {
        const {classes,dispatch,list,page,total,showModal,permissionMap, roles} = this.props
        return (
            <div>
                 {permissionMap['模块管理_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'add'})}>新增模块</Button>}
                 <Paper className={classes.root}>
                    {list.length === 0 && <NoData />}
                    {list.length > 0 && <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>模块名称</TableCell>
                                <TableCell>父菜单名称</TableCell>
                                <TableCell>路径</TableCell>
                                {permissionMap['模块管理_修改'] && <TableCell>操作</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map((row,index) => {
                                return (
                                    <TableRow key={index} style={{opacity: row.isClose ? '0.5' : '1',height: 80}}>
                                        <TableCell>{row.name}</TableCell>
                                        <TableCell>{row.parentName || '无'}</TableCell>
                                        <TableCell className={classes.contentCell}>{row.path || '-'}</TableCell>
                                        {permissionMap['模块管理_修改'] && <TableCell>
                                            <Tooltip id="clear" title={row.isClose ? '激活' : '关闭'}>
                                                <IconButton color="primary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'close',id: row.id,isClose: !row.isClose})}>{row.isClose ? <CheckCircleIcon /> : <BlockIcon />}</IconButton>
                                            </Tooltip>
                                            <Tooltip id="clear" title="删除">
                                                <IconButton color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'delete',id: row.id})}><ClearIcon /></IconButton>
                                            </Tooltip>
                                        </TableCell>}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                        <TableFooter>
                            <Pagination
                                total={total}
                                {...page}
                                onPageClick={this.onPageClick}
                            />
                        </TableFooter>
                    </Table>}
                </Paper>
                <Dialog
                    open={showModal.add}
                    fullScreen
                    onClose={() => dispatch({type: actions.HIDE_MODAL})}
                    TransitionComponent={Transition}
                >
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <Typography variant="title" color="inherit" className={classes.flex}>
                                新增代码
                            </Typography>
                            <IconButton color="inherit" onClick={() => dispatch({type: actions.HIDE_MODAL})}>
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <div className={classes.contentRoot}>
                        <ListForm
                            onSubmit={this.handleFormSubmit.bind(this)}
                            onCancel={() => dispatch({type: actions.HIDE_MODAL})}
                            modules={list}
                            roles={roles}
                        />
                    </div>
                </Dialog>
                <Dialog
                    open={showModal.delete}
                    onClose={() => dispatch({type: actions.HIDE_MODAL})}
                    fullWidth
                >
                    <DialogContent>确定删除吗？</DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                        <Button variant="outlined" color="primary" onClick={() => dispatch(actions.remove(showModal.id))}>确定</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={showModal.close}
                    onClose={() => dispatch({type: actions.HIDE_MODAL})}
                    fullWidth
                >
                    <DialogContent>确定{showModal.isClose ? '关闭' : '激活' }吗？</DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                        <Button variant="outlined" color="primary" onClick={() => dispatch(actions.update())}>确定</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.modules,
        permissionMap: state.auth.user.permissionMap
    }
}
export default connect(mapStateToProps)(withStyles(styles)(Modules))


// WEBPACK FOOTER //
// ./src/pages/home/routes/modules/components/list.js